import { canWith } from './rbacPermissions';

/** @param {Record<string, unknown> | null | undefined} permSummary */
export function currentRole(permSummary, authMe) {
  return (
    (permSummary && (permSummary.current_role || permSummary.module_role)) ||
    (authMe && authMe.role) ||
    ''
  );
}

/** Colaborador puro: portal propio, sin consola operativa RRHH. */
export function isEmployeeHubPersona(permSummary, authMe, isProductionUi) {
  const role = currentRole(permSummary, authMe);
  if (role === 'employee_self_service') {
    return !canWith(permSummary, 'employees', 'view', isProductionUi);
  }
  if (role === 'viewer') return true;
  return false;
}

export function isManagerPersona(permSummary, isProductionUi) {
  return (
    canWith(permSummary, 'leaves', 'approve', isProductionUi) ||
    canWith(permSummary, 'expenses', 'approve', isProductionUi)
  );
}

export function isRrhhOperatorPersona(permSummary, authMe, isProductionUi) {
  const role = currentRole(permSummary, authMe);
  if (['rrhh_admin', 'rrhh_operator'].includes(role)) return true;
  return canWith(permSummary, 'employees', 'edit', isProductionUi);
}
